export const getAvailablePaymentMethods = (configCheckoutPaymentMethods) => {
    let paymentMethods = {
        canUseCreditCard: false,
        canUseBankTransfer: false,
        canUseChargeAccount: false,
        canUseSavedCard: false,
        canUsePayFast: false,
    };

    if (configCheckoutPaymentMethods) {
        configCheckoutPaymentMethods.forEach(method => {
            switch(method) {
                case 'order-card':
                case 'order-card-authorization':
                case 'order-card-reference':
                    paymentMethods.canUseCreditCard = true;
                    break;

                case 'order-token':
                    paymentMethods.canUseCreditCard = true;
                    paymentMethods.canUseSavedCard = true;
                    break;

                case 'order-bank-transfer':
                    paymentMethods.canUseBankTransfer = true;
                    break;

                case 'order-account':
                    paymentMethods.canUseChargeAccount = true;
                    break;
                case 'order-card-authorization-payfast':
                    paymentMethods.canUsePayFast = true;
                    break;
            }
        });
    }

    return paymentMethods;
};
